import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import { HomeAppContext } from "../Home";
import api from "../../Services/api";
import { errorManagement } from "../../Services/errorManagement";
import AssistantChatForm from "./AssistantChatForm";
import GenericDialog from "../GenericDialog";

const initialEntry = {
  assistantId: "",
  assistantName: "",
  prompt: "",
  fileIds: [],
  continueThread: false,
  runId: "",
  threadId: ""
};

export default function RunAssistant({ open, setOpen, onCreate, assistant }) {
  const { homeState, homeDispatch } = useContext(HomeAppContext);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [errors, setErrors] = useState([]);
  const [internalEntry, setInternalEntry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [aiResponse, setAIResponse] = useState(null);
  const [continueThread, setContinueThread] = useState(false);
  const [assistantRunId, setAssistantRunId] = useState("");
  const [assistantThreadId, setAssistantThreadId] = useState("");
  const [canUpload, setCanUpload] = useState(false);

  React.useEffect(() => {
    if (open) {
      setSubmitted(false);
      setErrors([]);
      setInternalEntry({
        ...initialEntry,
        assistantId: assistant.id,
        assistantName: assistant.name
      });
      setLoading(false);
      setAIResponse(null);
      setContinueThread(false);
      setCanUpload((assistant.createdBy !== homeState.userProfile.userId) && (assistant.shareType === 1));
    } else {
      setInternalEntry(null);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    setLoading(true);
  };

  const handleRunAssistant = () => {
    setLoading(true);
    const runAssistantRequest = {
      assistantName: internalEntry.assistantName,
      assistantId: internalEntry.assistantId,
      prompt: internalEntry.prompt,
      fileIds: internalEntry.fileIds,
      continueThread: false
    };
    homeDispatch({
      type: "NOTIFICATION",
      data: {
        message: "Running AI Assistant " + internalEntry.assistantName,
        loading: true
      }
    });
    api
      .post(`/api/ai-assistants/run`, runAssistantRequest)
      .then((response) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: "Running AI Assistant " + internalEntry.assistantName,
            type: "success"
          }
        });
        setContinueThread(true);
        setAIResponse(response.data);
        setAssistantRunId(response.data.runId);
        setAssistantThreadId(response.data.threadId);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        errorManagement.formErrors(error, homeDispatch, setErrors);
      });
  };

  const handleContinueThread = () => {
    setLoading(true);
    const runAssistantRequest = {
      assistantName: internalEntry.assistantName,
      assistantId: internalEntry.assistantId,
      prompt: internalEntry.prompt,
      fileIds: internalEntry.fileIds,
      runId: assistantRunId,
      threadId: assistantThreadId,
      continueThread: true
    };
    homeDispatch({
      type: "NOTIFICATION",
      data: {
        message: "Running AI Assistant " + internalEntry.assistantName,
        loading: true
      }
    });
    api
      .post(`/api/ai-assistants/run`, runAssistantRequest)
      .then((response) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: "Running AI Assistant " + internalEntry.assistantName,
            type: "success"
          }
        });
        setContinueThread(true);
        setAIResponse(response.data);
        setInternalEntry((prevState) => ({
          ...prevState,
          assistantRunId: response.data.assistantRunId,
          assistantThreadId: response.data.assistantThreadId
        }));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        errorManagement.formErrors(error, homeDispatch, setErrors);
      });
  };
  const actions = (
    <>
      <Button onClick={handleClose} disabled={loading}>
        Cancel
      </Button>
      {continueThread === false ? (
        <Button
          onClick={handleRunAssistant}
          color="primary"
          variant="outlined"
          autoFocus
          disabled={loading || saveDisabled}
        >
          Run Assistant
        </Button>
      ) : (
        <Button
          onClick={handleContinueThread}
          color="primary"
          variant="outlined"
          autoFocus
          disabled={loading || saveDisabled}
        >
          Continue Thread
        </Button>
      )}
    </>
  )
  return internalEntry === null ? null : (
    <GenericDialog
      maxWidth={"md"}
      open={open}
      onClose={handleClose}
      title={'Run Assistant "' + internalEntry.assistantName + '"'}
      actions={actions}
    >
        <AssistantChatForm
          entity={internalEntry}
          errors={errors}
          setEntity={setInternalEntry}
          result={aiResponse}
          loading={loading}
          submitted={submitted}
          setSaveDisabled={setSaveDisabled}
          canUpload={canUpload}
        />
    </GenericDialog>
  );
}
